import { render, staticRenderFns } from "./RxDocumentos.vue?vue&type=template&id=0552ba42&scoped=true&"
import script from "./RxDocumentos.vue?vue&type=script&lang=ts&"
export * from "./RxDocumentos.vue?vue&type=script&lang=ts&"
import style0 from "./RxDocumentos.vue?vue&type=style&index=0&id=0552ba42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552ba42",
  null
  
)

export default component.exports